import { Edit3Icon } from '@popsure/dirty-swan';
import classNames from 'classnames';
import routes from 'constants/routes';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { generatePath, Link } from 'react-router-dom';
import { useSafeTranslation } from 'shared/i18n';
import { isMobileApp } from 'shared/util/isMobileApp';

import { PolicyDetailsButtonProps } from '../../sections/PolicyDetails/PolicyDetails.models';
import styles from './AdjustPolicyButton.module.scss';

dayjs.extend(isSameOrAfter);
export const AdjustPolicyButton = ({
  policyData: {
    status,
    id,
    type,
    attributes: { startDate },
  },
}: PolicyDetailsButtonProps) => {
  const { t } = useSafeTranslation();

  const hasPendingPolicyAdjustment =
    status === 'ACTIVE' && !dayjs().isSameOrAfter(startDate);

  return (
    <Link
      className={classNames(
        'br8 d-flex ai-center jc-between c-pointer',
        styles.buttonContainer,
        {
          [styles['buttonContainer--no-hover']]:
            isMobileApp || hasPendingPolicyAdjustment,
          [styles.disabled]: hasPendingPolicyAdjustment,
        }
      )}
      to={generatePath(routes.me.policies.adjustPolicy.path, {
        policyId: id,
        verticalId: type.toLowerCase(),
      })}
    >
      <div className={styles.buttonContainerContent}>
        <Edit3Icon noMargin size={24} className="ml16" />
        <div className={styles.title}>
          {t(
            'myPolicies.policyDetails.adjustPolicyButton.caption',
            'Adjust policy'
          )}
        </div>
      </div>
    </Link>
  );
};
